import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import { useDispatch } from 'react-redux';
import ErrorBoundary from '../../components/ErrorBoundary';
import EmptyResult from '../../components/EmptyResult';
import FilteredContext from '../../contexts/FilteredContext';
import TTCContainer from '../TTCContainer';
import i18next from '../../translations/i18n';
import { setStories, getAssetClasses, fetchStories } from '../../redux/slices';

/* For dev tests */
/* window.ttCentre = {
  isoCode: 'it-IT',
  origin: 'https://sitecore10prod.wisdomtree.eu',
};
 */
const TacticalTradingApp = () => {
  const dispatch = useDispatch();

  const [storiesList, setPostStories] = useState([]);
  let interval;
  const loadContent = async () => {
    await dispatch(getAssetClasses());
  }; // end loadContent

  useEffect(() => {
    const init = async () => {
      await loadContent();
      if (!interval) {
        interval = setInterval(loadContent, 1000 * 10);
      }
    };
    init();
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    dispatch(fetchStories({ page: 1 }))
      .unwrap()
      .then((result) => {
        const updatedStories = result.stories.map((story, idx) => ({
          ...story.content,
          _uid: story.content._uid + idx,
          created_at: story.created_at,
        }));

        setPostStories(updatedStories);
        dispatch(setStories(updatedStories));
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch stories', err);
      });
  }, [dispatch]);
  if (!storiesList || storiesList.length === 0) {
    return <EmptyResult message={i18next.t('NoPostToDisplay')} />;
  }

  return (
    <FilteredContext.Provider>
      <ErrorBoundary>
        <Container fluid className="">
          <TTCContainer />
        </Container>
      </ErrorBoundary>
    </FilteredContext.Provider>
  );
};
export default TacticalTradingApp;
